module.exports = __webpack_public_path__ + "img/ch13_14_夺手机.b538df49.jpg";